import { render, staticRenderFns } from "./CdkImageDetail.vue?vue&type=template&id=4d2a3c2a&scoped=true&functional=true&"
import script from "./CdkImageDetail.vue?vue&type=script&lang=ts&"
export * from "./CdkImageDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CdkImageDetail.vue?vue&type=style&index=0&id=4d2a3c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4d2a3c2a",
  null
  
)

export default component.exports